import {
  useMediaQuery,
  WIDE_DESKTOP,
} from '@porterin/feature/src/shared/core/hooks/useMediaQuery';
import { MODAL_CLOSE_TIMEOUT_NONE } from '@porterin/feature/src/shared/modal/domain/entities/ModalEntities';
import React from 'react';
import ReactModal from 'react-modal';

import { make as EditBookingDetailsDesktopWrapperCmp } from '../../modals/EditBookingDetailsDesktopWrapperCmp.mjs';
import { make as EditBookingDetailsMobileWrapperCmp } from '../../modals/EditBookingDetailsMobileWrapperCmp.mjs';
import styles from '../styles/BookingDetails.module.scss';

interface BookingDetailsModalProps {
  modal_state: boolean;
  close_modal: () => void;
  waypoint: number;
  is_address_modal_open?: boolean;
}

function BookingDetailsModal({
  modal_state,
  close_modal,
  waypoint,
  is_address_modal_open = false,
}: Readonly<BookingDetailsModalProps>): React.ReactElement {
  const isWideDesktop = useMediaQuery(WIDE_DESKTOP);
  return (
    <ReactModal
      isOpen={modal_state}
      onRequestClose={close_modal}
      closeTimeoutMS={MODAL_CLOSE_TIMEOUT_NONE}
      overlayClassName={styles['overlay']}
      className={styles['modal-container']}
      ariaHideApp={false}
      shouldCloseOnOverlayClick
    >
      {isWideDesktop ? (
        <EditBookingDetailsDesktopWrapperCmp
          close_modal={close_modal}
          waypoint={waypoint}
        />
      ) : (
        <EditBookingDetailsMobileWrapperCmp
          close_modal={close_modal}
          waypoint={waypoint}
          is_address_modal_open={is_address_modal_open}
        />
      )}
    </ReactModal>
  );
}

export default BookingDetailsModal;
